module.exports = __webpack_public_path__ + "img/cropped-rylan-hill-pf-eZzTvVzk-unsplash-compressed-lazy.2dcb0af4.webp";